import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
    const location = useLocation();
    const adminToken = localStorage.getItem('adminToken');

    if (!adminToken) {
        // Redirect to admin login page but save the attempted url
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
};

export default AdminProtectedRoute; 